/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_CREDITOR_SUPLIER, ContactType, CreditorType } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsCreditorCommonTabComponent,
  ContactDetailsCreditorSubContractorTabComponent,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
  ContactDetailsSharedPortalTabComponent,
  ContactDetailsSharedTermsPayeeTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsCreditorFormState } from './contact-details-creditor-form.service';

@Component({
  selector: 'gh-contact-details-creditor-tab',
  template: require('./contact-details-creditor-tab.component.html'),
})
export class ContactDetailsCreditorTabComponent {
  routes = [
    createContextRoute({
      component: ContactDetailsCreditorCommonTabComponent,
      path: 'common',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initCreditorCommonTabView',
      },
    }),
    createContextRoute({
      component: ContactDetailsCreditorSubContractorTabComponent,
      path: 'subContractor',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initCreditorSubContractorTabView',
      },
    }),

    createContextRoute({
      component: ContactDetailsSharedTermsPayeeTabComponent,
      path: 'terms',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedTermsPayeeTabView',
      },
      static: {
        tab: 'creditorSupplier',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'creditorSupplier',
        contactType: CONTACT_TYPE_CREDITOR_SUPLIER,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'creditorSupplier',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedPortalTabComponent,
      path: 'portal',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initInvitations',
      },
      static: {
        tab: 'creditorSupplier',
        type: CONTACT_TYPE_CREDITOR_SUPLIER,
      },
    }),
  ];

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsCreditorFormState,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('creditorSupplier');
  }

  get hasSubContractor(): boolean {
    return this.form.value.common.type === CreditorType.SubContractor;
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
